module.exports = __webpack_public_path__ + "img/2-2.d5502a38.jpg";